import styled from "styled-components";

export const Title = styled.div`
  color: #222;
  font-weight: bold;
  font-size: 1.5rem;
  display: inline-block;
  &:hover {
    cursor: pointer;
    text-decoration: underline;
  }
`;

export const PostHeaderContainer = styled.div`
  color: #777;
`;
